import { DeleteOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Popover,
  Row,
  Select,
} from "antd";
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import SelectTextEditorSingleWord from "components/UI/editor/selectTextEditorSingleWord";
import {
  convertHighlightsToBlanks,
  getEditedLabels,
  getLabels,
  moodsOption,
  pronounOptions,
  reorderOptions,
} from "modules/workSheet/helper";
import React, { memo, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { Close } from '@mui/icons-material';
import COLORS from "utils/constants/color";
import TextEditor from "components/TextEditor";
import PictureAssignment from "components/Image/PictureAssignment";
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { useTabletDetection } from "containers/chat/hooks";
import ReactPlayer from "react-player";
import { Info } from '@mui/icons-material';
import {
  handleGeneratePronounDetails,
  handleElevenLabsWithAudio,
  handleGenerateWrongAnswerFeedBack,
  handleQuestionMediaWorkSheet,
} from "store/vocabulary/thunks";
import Loading from "components/Loading";
import { detectTextLanguage } from "utils/config/reference";
import RegenerateUsingAI from "./regenerateUsingAi";
import TranscriptWithAudio from "components/UI/transcriptWithAudio/transcriptWithAudio";
import SentryWrap from 'components/Sentry';

const { TextArea } = Input;

const QuestionComponent = ({
  index,
  type,
  onQuestionChange,
  questionData,
  nouns,
  setNouns,
  hintDetail,
  setHintDetail,
  isOpen,
  typeField,
  isEdit,
}) => {
  const showAlert = useAlert();
  const [loaderAudio, setLoaderAudio] = useState({});
  const [loaderMedia, setLoaderMedia] = useState(false);
  const [loaderAudioAnswer, setLoaderAudioAnswer] = useState({});
  const [dropdownVisibility, setDropdownVisibility] = useState({
    mood: false,
    tenses: false,
    categories: false,
    pronouns: false,
    questionType: false,
    questionLength: false,
  });
  const [generatePronounsDetails, setGeneratePronounsDetails] = useState(false);
  const smileIcon = "";
  const [generateFeedback, setGenerateFeedback] = useState(false);
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);
  const getTenseOptionData = useMemo(() => {
    const moodSelected =  !isNaN(questionData?.mood) ? getLabels(questionData?.mood, moodsOption)?.toString() : getEditedLabels(questionData?.mood, moodsOption)?.toString();
    const filteredData = moodsOption?.find((x) => x?.label === moodSelected);
    const getTenseoption = filteredData?.tenseOptions;
    return getTenseoption || [];
  }, [questionData?.mood]);

  const isTablate = useTabletDetection();
  const getCategoryOption = useMemo(() => {
    const tenseSelected = !isNaN(questionData?.tense) ? getLabels(questionData?.tense, getTenseOptionData)?.toString() : getEditedLabels(questionData?.tense, getTenseOptionData)?.toString();

    const filteredData = getTenseOptionData?.find(
      (x) => x?.label === tenseSelected
    );
    const getCategoryOption = filteredData?.categoryOptions;

    return getCategoryOption || [];
  }, [questionData?.tense, getTenseOptionData]);

  const handleChange = (
    field,
    value,
    optionIndex = null,
    hintDetailIndex = null,
    pronounIndex = null
  ) => {
    try {
      const updatedData = { ...questionData };
      if (optionIndex !== null) {
        updatedData.options[optionIndex] = value;
      } else if (hintDetailIndex !== null) {
        const updatedHintDetail = [...updatedData.hintDetail];
        updatedHintDetail[hintDetailIndex] = {
          ...updatedHintDetail[hintDetailIndex],
          ...value,
        };
        updatedData.hintDetail = updatedHintDetail;
      } else if (pronounIndex !== null) {
        const updatedPronouns = [...updatedData.pronounsDetailOption];
        updatedPronouns[pronounIndex] = {
          ...updatedPronouns[pronounIndex],
          ...value,
        };
        updatedData.pronounsDetailOption = updatedPronouns;
      } else {
        if (field === "question" && questionData?.question !== value) {
          if(questionData?.type === "Fill_IN_THE_Blank"){
            updatedData.question_audio = "";
            updatedData.answer_audio = "";
          }else{
            updatedData.question_audio = "";
          }
          setNouns((prevNouns) => {
            const updatedNouns = [...prevNouns];
            updatedNouns[index] = "";
            return updatedNouns;
          });
        }
        if (field === "correct_answer" && questionData?.correct_answer !== value) {
          updatedData.answer_audio = "";
          updatedData.wrongAnswerFeedBack = "";
        }
        if(field === "tense" && isEdit){
          updatedData.category = "";
        }
        updatedData[field] = value;
      }

      onQuestionChange(updatedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (questionData?.type !== "Fill_IN_THE_Blank") {
      if (
        questionData.correct_answer &&
        !questionData.options.includes(questionData.correct_answer)
      ) {
        handleChange("correct_answer", "");
      }
    }
  }, [questionData.options]);

  const removeHighlightWord = (indexToRemove) => {
    if (questionData?.highlightWords) {
      const updatedHighlights = questionData.highlightWords.filter(
        (_, index) => index !== indexToRemove
      );
      handleChange("highlightWords", updatedHighlights);
    }
  };

  const addOption = () => {
    const updatedOptions = [...questionData.options, ""];
    handleChange("options", updatedOptions);
  };

  const removeOption = (indexToRemove) => {
    const updatedOptions = questionData.options.filter(
      (_, index) => index !== indexToRemove
    );

    // Ensure at least 2 options remain
    if (updatedOptions.length >= 2) {
      handleChange("options", updatedOptions);
    }
  };

  const submitHandler = (data) => {
    try {
      const updatedData = { ...questionData };
      updatedData.highlightWords = data;
      
      if (data && Array.isArray(data) && data.length > 0) {
        const firstHighlight = data[0];
        if (firstHighlight && firstHighlight.text) {
          updatedData.correct_answer = firstHighlight.text;
        } else if (data.length === 0) {
          updatedData.correct_answer = "";
        }
      } else {
        updatedData.correct_answer = "";
      }
      
      onQuestionChange(updatedData);
    } catch (error) {
      console.log(error);
      handleChange("highlightWords", data);
    }
  };

  const addHintDetail = () => {
    const updatedHintDetail = [
      ...questionData.hintDetail,
      { word: "", meaning: "" },
    ];
    handleChange("hintDetail", updatedHintDetail);
  };

  const removeHintDetail = (indexToRemove) => {
    const updatedHintDetail = questionData.hintDetail.filter(
      (_, index) => index !== indexToRemove
    );

    if (updatedHintDetail.length >= 1) {
      handleChange("hintDetail", updatedHintDetail);
    }
  };



  const renderQuestionFields = useMemo(() => {
    switch (type) {
      case "Fill_IN_THE_Blank":
        return (
          <>
            <div
              className="flex justify-between gap-10px"
              // style={{ marginTop: -45 }}
            >
              <div className="flex-1">
                <Form.Item
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        width:"100%"
                      }}
                    >
                      Question Text
                      <Popover
                        overlayInnerStyle={{ maxWidth: "300px" }}
                        placement="top"
                        overlayStyle={{ zIndex: 9999 }}
                        content="The main question content. It can be generated with AI or written manually by the admin."
                        trigger="hover"
                      >
                        <Info
                          style={{ cursor: "pointer", fontSize: "20px" }}
                        />
                      </Popover>
                    </span>
                  }
                >
                  <TextArea
                    value={questionData?.question}
                    onChange={(e) => handleChange("question", e.target.value)}
                    placeholder="Enter question text with blank"
                    rows={1}
                    style={{ resize: "none", height: "100%" }}
                  />
                </Form.Item>
              </div>
              {questionData?.question?.length > 0 && (
                <Form.Item
                  label="Select Hightlight"
                  style={{ maxWidth: "50%", flex: "1" }}
                >
                  <SelectTextEditorSingleWord
                    highlights={questionData?.highlightWords}
                    initialText={questionData?.question}
                    setHighlights={submitHandler}
                    from={"worksheet"}
                  />
                </Form.Item>
              )}
            </div>
            <HighlightsSection>
              {questionData?.highlightWords &&
              questionData?.highlightWords?.length > 0 ? (
                <HighlightsList>
                  <HighlightContainer>
                    {questionData?.highlightWords?.map((highlight, idx) => (
                      <HighlightItem key={idx}>
                        <HighlightText>
                          {idx + 1}
                          {". "}
                          {highlight.text}
                        </HighlightText>
                        <DeleteButton onClick={() => removeHighlightWord(idx)}>
                          <Close style={{ fontSize: 16 }} />
                        </DeleteButton>
                      </HighlightItem>
                    ))}
                  </HighlightContainer>
                </HighlightsList>
              ) : (
                <EmptyHighlightItem>
                  No selected highlight's available
                </EmptyHighlightItem>
              )}
            </HighlightsSection>
          </>
        );
      case "Translate_Text":
      case "Select_Correct_Response":
      case "Select_What_You_Hear":
        return (
          <>
            <Form.Item
              label={
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px", width:"100%" }}
                >
                  Question Text
                  <Popover
                    overlayInnerStyle={{ maxWidth: "300px" }}
                    placement="top"
                    overlayStyle={{ zIndex: 9999 }}
                    content="The main question content. It can be generated with AI or written manually by the admin."
                    trigger="hover"
                  >
                    <Info style={{ cursor: "pointer", fontSize: "20px" }} />
                  </Popover>
                </span>
              }
            >
              <TextArea
                value={questionData?.question}
                onChange={(e) => handleChange("question", e.target.value)}
                placeholder="Enter question text"
                rows={1}
              />
            </Form.Item>
            <div style={{ display: "flex", gap: 10 }}>
              {questionData?.options?.map((option, index) => (
                <Form.Item
                  style={{ width: "49%" }}
                  key={index}
                  // label={`Option ${index + 1}`}
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      {`Option ${index + 1}`}
                      <Popover
                        placement="top"
                        overlayInnerStyle={{ maxWidth: "300px" }}
                        overlayStyle={{ zIndex: 9999 }}
                        content={
                          index === 0
                            ? "The first answer choice, which can be edited or entered manually if needed."
                            : "The second answer choice, which can also be modified or entered manually."
                        }
                        trigger="hover"
                      >
                        <Info
                          style={{ cursor: "pointer", fontSize: "20px" }}
                        />
                      </Popover>
                    </span>
                  }
                  extra={
                    questionData.options.length > 2 && (
                      <Button
                        type="link"
                        icon={<DeleteOutlined />}
                        onClick={() => removeOption(index)}
                        danger
                      >
                        Remove Option
                      </Button>
                    )
                  }
                >
                  <Input
                    value={option}
                    onChange={(e) =>
                      handleChange("options", e.target.value, index)
                    }
                    placeholder={`Enter option ${index + 1}`}
                    suffix={
                      ""
                      // index === questionData.options.length - 1 && (
                      //   <Button
                      //     type="text"
                      //     icon={<PlusOutlined />}
                      //     onClick={addOption}
                      //   />
                      // )
                    }
                  />
                </Form.Item>
              ))}
            </div>
            <Form.Item
              label={
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  Correct Answer
                  <Popover
                    overlayInnerStyle={{ maxWidth: "300px" }}
                    placement="top"
                    overlayStyle={{ zIndex: 9999 }}
                    content="The correct response between the options. Admins can confirm the AI suggestion or input one manually."
                    trigger="hover"
                  >
                    <Info style={{ cursor: "pointer", fontSize: "20px" }} />
                  </Popover>
                </span>
              }
            >
              <Select
                style={{ width: "100%" }}
                value={questionData?.correct_answer}
                onChange={(value) => handleChange("correct_answer", value)}
                placeholder="Select Correct Answer"
                allowClear
              >
                {questionData?.options
                  ?.filter((option) => option.trim() !== "")
                  ?.map((option, index) => (
                    <Select.Option key={index} value={option}>
                      {option}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </>
        );
      default:
        return null;
    }
  }, [
    type,
    questionData?.question,
    questionData?.options,
    questionData?.correct_answer,
    questionData?.hintDetail,
    questionData?.highlightWords,
    handleChange,
    submitHandler,
    addOption,
    removeOption,
    addHintDetail,
    removeHintDetail,
  ]);

  const renderFormField = (
    label,
    state,
    setState,
    options,
    mode,
    conditionalRender,
    disabled = false
  ) => {
    const moodSelected = getLabels(questionData?.mood, moodsOption)?.toString();

    const modifiedOptions = options.map((option) => {
      const moodSelected = getLabels(
        questionData?.mood,
        moodsOption
      )?.toString();

      if (option.label === "yo" && moodSelected === "Imperative") {
        return { ...option, disabled: true };
      }
      return { ...option, disabled: false };
    });

    const reorderedOptions = reorderOptions(modifiedOptions, state);

    const shouldRender = conditionalRender
      ? conditionalRender(label, state)
      : true;

    if (!shouldRender) return null;

    const handleDropdownVisibleChange = (visible, currentLabel) => {
      setDropdownVisibility((prevVisibility) => ({
        ...prevVisibility,
        [currentLabel]: visible,
      }));
    };

    if (moodSelected === "Imperative" && label === "Tense") {
      return null;
    }

    if (
      moodSelected === "Imperative" &&
      label === "category" &&
      questionData?.mood !== null
    ) {
      return null;
    } else if (
      moodSelected !== "Imperative" &&
      label === "category" &&
      questionData?.mood !== null &&
      questionData?.tenses !== null
    ) {
      return null;
    }

    return (
      <Select
        suffixIcon={
          mode === "single" ? (
            dropdownVisibility[label] ? (
              <ArrowDropUp
                style={{
                  color: "rgba(0, 0, 0, 0.54)",
                  fontSize: 24,
                  zIndex: 9,
                }}
              />
            ) : (
              <ArrowDropDown
                style={{
                  color: "rgba(0, 0, 0, 0.54)",
                  fontSize: 24,
                  zIndex: 9,
                }}
              />
            )
          ) : (
            smileIcon
          )
        }
        variant="borderless"
        mode={mode === "multiple" ? "multiple" : undefined}
        style={{ width: "100%" }}
        options={reorderedOptions}
        placeholder={`Select ${label}`}
        maxTagCount="responsive"
        value={state}
        onChange={(selected) =>
          setState(mode === "multiple" ? selected : selected)
        }
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        onDropdownVisibleChange={(e) => handleDropdownVisibleChange(e, label)}
        open={dropdownVisibility[label]}
        disabled={disabled}
      />
    );
  };

  const renderImageUploder = () => {
    return (
      <Form.Item
        label={
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            Question Image
            <Popover
              overlayInnerStyle={{ maxWidth: "300px" }}
              placement="top"
              overlayStyle={{ zIndex: 9999 }}
              content="An image related to the question. It can be generated by AI or uploaded manually by the admin."
              trigger="hover"
            >
              <Info style={{ cursor: "pointer", fontSize: "20px" }} />
            </Popover>
          </span>
        }
        rules={[
          {
            validator: () => {
              if (!questionData?.image || questionData?.image === "") {
                return Promise.reject(new Error("Question image is required"));
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <PictureAssignment
          source={questionData?.image}
          style={{
            marginTop: questionData?.image
              ? window.innerWidth >= 1024
                ? "130px"
                : "85px"
              : "",
          }}
          imageClassName={`assignment-image assignment-grammer-drill-image  ${
            isTablate ? "assignmentTabImg" : ""
          }`}
          containerClassName="assignment-ebook newAssignmentEbookNw"
          type={"student"}
          showImagePicker={true}
          handlePicture={(url) => handleChange("image", url)}
        />
      </Form.Item>
    );
  };

  const onHandleAudio = async (text) => {
    if (!questionData?.question || questionData?.question?.length === 0) {
      showAlert("Please type the question first before generating audio.", "error");
      return;
    }
    const blankQuestion = convertHighlightsToBlanks(
      text?.question,
      text?.highlightWords
    );

    setLoaderAudio({ index, value: true });

    const detectLanguageType = await detectTextLanguage(text?.question);
    try {
       const payloadData = {
        text:  questionData?.type === "Fill_IN_THE_Blank"
            ? blankQuestion : text?.question,
        pitch:"",
        volume:"",
        speed:"",
        voice_name :"es-ES-Neural2-A",
        voice_languageCodes :"es-ES",
        gender: "FEMALE"
      }
      const data = await handleElevenLabsWithAudio(payloadData);

      // const payload = {
      //   text:
      //     questionData?.type === "Fill_IN_THE_Blank"
      //       ? blankQuestion
      //       : text?.question,
      //   language: detectLanguageType === "en-US" ? "ENGLISH" : "SPANISH",
      //   gender: "FEMALE",
      // };

      // const data = await handleQuestionAudioWorkSheet(payload);
      if (data?.statusCode === 400) {
        showAlert("Audio is not generated.", "error");
        setLoaderAudio({});
        return;
      }
      const audioUrl = data?.url;

      if (audioUrl) {
        await handleChange("question_audio", audioUrl);
      }

      setLoaderAudio({});
    } catch (error) {
      console.log(error);
      setLoaderAudio({});
    }
  };

  const onHandleMedia = async (text, description) => {
    let data = null;
    if (description) {
      data = {
        question: text,
        question_type: text?.type,
        description: description
      };
    } else {
      data = {
        question: text,
        question_type: text?.type,
      };
    }
    setLoaderMedia(true);
    const mediaData = await handleQuestionMediaWorkSheet(data);
    if (mediaData?.statusCode === 400 || !mediaData?.data) {
      showAlert("Image is not generated.", "error");
      setLoaderMedia(false);
      return;
    }
    const mediaUrl = mediaData?.data[0];

    if (mediaUrl) {
      await handleChange("tempImage", mediaUrl);
      setLoaderMedia(false);
      return mediaUrl;
    }
    setLoaderMedia(false);
  };

  const onHandleAudioAnswer = async (text) => {
    if (!questionData?.question || questionData?.question?.length === 0) {
      showAlert("Please type the question first before generating audio.", "error");
      return;
    }

    setLoaderAudioAnswer({ index, value: true });
    const detectLanguageType = await detectTextLanguage(text?.question);
    try {

      const payloadData = {
        text: text,
        pitch:"",
        volume:"",
        speed:"",
        voice_name :"es-ES-Neural2-A",
        voice_languageCodes :"es-ES",
        gender: "FEMALE"
      }
      const data = await handleElevenLabsWithAudio(payloadData);



      // const payload = {
      //   text,
      //   language: detectLanguageType === "en-US" ? "ENGLISH" : "SPANISH",
      //   gender: "FEMALE",
      // };

      // const data = await handleQuestionAudioWorkSheet(payload);
      if (data?.statusCode === 400) {
        showAlert("Audio is not generated.", "error");
        setLoaderAudioAnswer({});
        return;
      }

      const audioUrl = data?.url;

      if (audioUrl) {
        await handleChange("answer_audio", audioUrl);
      }

      setLoaderAudioAnswer({});
    } catch (error) {
      console.log(error);
      setLoaderAudioAnswer({});
    }
    finally{
      setLoaderAudioAnswer({});
    }
  };

  function replaceVerbInSentence(sentence) {
    const match = sentence.match(/\(([^)]+)\)/);
    if (!match) return sentence;
    return sentence.replace(/\s*\([^)]+\)/, ""); // Remove the parenthesis
  }


  const handlerPronounDetails = async (language) => {
    try {
      setGeneratePronounsDetails(true);
      const data = await handleGeneratePronounDetails({
        language,
        question: questionData,
      });
      if (data?.data) {
        let pronounDetails = data.data?.pronounDetails || "";
        pronounDetails = pronounDetails.replace(/^```html\n?/i, "").replace(/\n?```$/g, "").trim();
        setNouns((prevNouns) => {
          const updatedNouns = [...prevNouns];
          updatedNouns[index] = pronounDetails;
          return updatedNouns;
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setGeneratePronounsDetails(false);
    }
  };



  const generateWrongAnswerFeedBack = async (language) => {
    try {
      setGenerateFeedback(true);
      const payload = {
        question: questionData,
        language: language,
      };
     const feedback = await handleGenerateWrongAnswerFeedBack(payload);
     if(feedback?.data){
      showAlert("Wrong answer feedback generated successfully", "success");
      handleChange("wrongAnswerFeedBack", feedback?.data?.wrongAnswerFeedBack);
     }
    } catch (error) {
      console.log(error);
      setGenerateFeedback(false);
    }finally{
      setGenerateFeedback(false);
    }
  }
  return (
    <SentryWrap>
      <span style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end",color: "#1494de" }}>
         Question Used Count: <label color="black">{questionData?.usage_count}</label>
       </span>
    <Form layout="vertical">
      <Row>
        <Col span={12} className="leftAI">
          {typeField}
          {renderImageUploder()}
          <Row>
            <Col xs={12} md={12} lg={12}>
              {questionData?.question_audio &&
                questionData?.question_audio?.length > 0 && (
                  <div className="mb-10px">
                    <label style={{ marginLeft: 10 }}>Question Audio</label>
                    <TranscriptWithAudio audioUrl={questionData?.question_audio}>
                    <ReactPlayer
                      url={questionData?.question_audio}
                      height="40px"
                      className="custom-player"
                      width="100%"
                      controls
                      playsinline
                      config={{
                        file: { attributes: { controlsList: "nodownload" } },
                      }}
                    />
                    </TranscriptWithAudio>
                  </div>
                )}
            </Col>
            <Col xs={12} md={12} lg={12} style={{ paddingLeft: 10 }}>
              {questionData?.answer_audio &&
                questionData?.answer_audio?.length > 0 && (
                  <div className="mb-10px">
                    <label style={{ marginLeft: 10 }}>Answer Audio</label>
                    <TranscriptWithAudio audioUrl={questionData?.answer_audio}>
                    <ReactPlayer
                      url={questionData?.answer_audio}
                      height="40px"
                      className="custom-player"
                      width="100%"
                      controls
                      playsinline
                      config={{
                        file: { attributes: { controlsList: "nodownload" } },
                      }}
                    />
                    </TranscriptWithAudio>
                  </div>
                )}
            </Col>
            <Col xs={24} md={24} lg={24}>
              <SaveButton className="mb-20px flex w-full generateQuesImg">
                 <RegenerateUsingAI
                  index={index}
                  questionData={questionData}
                  src={questionData?.tempImage || questionData?.image}
                  onGenerateHandleMedia={onHandleMedia}
                  onImageChange={(data) => {
                    handleChange("image", data?.url);
                  }}
                  loaderMedia={loaderMedia}
                />
              
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    onHandleAudio(questionData);
                  }}
                  // disabled={questionData?.loaderAudio}
                  disabled={
                    questionData?.loaderAudio ||
                    (questionData?.type === "Fill_IN_THE_Blank" &&
                      (!Array.isArray(questionData?.highlightWords) ||
                        !questionData?.highlightWords?.[0]?.text))
                  }
                  style={{ background: "#03999e", color: "white" }}
                >
                  {loaderAudio?.index === index && loaderAudio?.value ? (
                    <Loading white={true} size={18} />
                  ) : (
                    "Generate Question Audio"
                  )}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    onHandleAudioAnswer(
                      questionData?.type === "Fill_IN_THE_Blank"
                        ? replaceVerbInSentence(questionData?.question)
                        : questionData?.correct_answer
                    );
                  }}
                  disabled={
                    questionData?.type === "Fill_IN_THE_Blank"
                      ? !questionData?.highlightWords ||
                        !questionData?.highlightWords[0]?.text
                      : !questionData?.correct_answer
                  }
                  style={{ background: "#03999e", color: "white" }}
                >
                  {loaderAudioAnswer?.index === index &&
                  loaderAudioAnswer?.value ? (
                    <Loading white={true} size={18} />
                  ) : (
                    "Generate Answer Audio"
                  )}
                </Button>
              </SaveButton>
            </Col>
          </Row>
          {renderQuestionFields}
        </Col>
        <Col span={12} className="rightAI">
          <DropdownContainer>
            <div className="grid-template-columns-two md-grid-template-one gap-10px">
              {[
                {
                  label: "Mood",
                  state: questionData?.mood,
                  setState: (data) => handleChange("mood", data),
                  options: moodsOption,
                  mode: "single",
                  tooltip:
                    "The grammatical mood (e.g., indicative, subjunctive, imperative). Select from the dropdown manually or adjust based on the generated content.",
                },
                {
                  label: "Tense",
                  state: questionData?.tense,
                  setState: (data) => handleChange("tense", data),
                  options: getTenseOptionData,
                  mode: "single",
                  tooltip:
                    "The verb tense (e.g., past, present, future). Choose from the dropdown manually or match it to the AI-generated content.",
                },
                {
                  label: "Categories",
                  state: questionData?.category,
                  setState: (data) => handleChange("category", data),
                  options: getCategoryOption,
                  mode: "single",
                  tooltip:
                    "The topic of the question (e.g., regular verbs, reflexive verbs, stem changes, etc.). Admins can select one or more from the dropdown, whether AI-suggested or chosen manually.",
                },
                {
                  label: "Pronouns Word",
                  state: questionData?.pronouns,
                  setState: (data) => handleChange("pronouns", data),
                  options: pronounOptions,
                  mode: "single",
                  tooltip:
                    "The subject pronoun(s) relevant to verb conjugation. Select one or more from the dropdown, either manually or based on the question content.",
                },
              ].map(
                ({
                  label,
                  state,
                  setState,
                  options,
                  mode,
                  conditionalRender,
                  tooltip,
                }) => {
                  const moodSelected = getLabels(
                    questionData?.mood,
                    moodsOption
                  )?.toString();
                  if (
                    (moodSelected === "Imperative" && label === "Tense") ||
                    (questionData?.mood === "Imperative" && label === "Tense")
                  ) {
                    return null;
                  }
                  return (
                    <>
                      <Form.Item
                        style={{
                          width: "100%",
                          ".ant-form-item-control": {
                            width: "100%",
                          },
                        }}
                        // label={label}
                        label={
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            {label}
                            <Popover
                              overlayInnerStyle={{ maxWidth: "300px" }}
                              placement="top"
                              overlayStyle={{ zIndex: 9999 }}
                              content={tooltip}
                              trigger="hover"
                            >
                              <Info
                                style={{ cursor: "pointer", fontSize: "20px" }}
                              />
                            </Popover>
                          </span>
                        }
                      >
                        {renderFormField(
                          label,
                          state,
                          setState,
                          options,
                          mode,
                          conditionalRender,
                          isEdit && label === "Mood"
                        )}
                      </Form.Item>
                    </>
                  );
                }
              )}
            </div>
            <Form.Item
              label={
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  Wrong Answer FeedBack
                  <Popover
                    overlayInnerStyle={{ maxWidth: "300px" }}
                    placement="top"
                    overlayStyle={{ zIndex: 9999 }}
                    content="A brief explanation of why an incorrect answer is wrong. Admins can use the AI version or write their own."
                    trigger="hover"
                  >
                    <Info style={{ cursor: "pointer", fontSize: "20px" }} />
                  </Popover>
                    <Button disabled={generateFeedback} onClick={() => generateWrongAnswerFeedBack("spanish")} variant="contained" color="primary" style={{ background: "#03999e", color: "white" }}> 
                      {generateFeedback ? <Loading white={true} size={18} /> : "Generate FeedBack"}
                    </Button>
                </span>
              }
            >
              <Input
                value={questionData?.wrongAnswerFeedBack}
                onChange={(e) =>
                  handleChange("wrongAnswerFeedBack", e.target.value)
                }
                placeholder="Enter the wrong answer feedback"
              />
            </Form.Item>
          </DropdownContainer>
          <Form.Item
            label={
              <span
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                Pronouns Details
                <Popover
                  overlayInnerStyle={{ maxWidth: "300px" }}
                  placement="top"
                  overlayStyle={{ zIndex: 9999 }}
                  content="A conjugation table showing how verbs are used with different pronouns. Can be modified or entered manually to highlight grammar points."
                  trigger="hover"
                >
                  <Info style={{ cursor: "pointer", fontSize: "20px" }} />
                </Popover>
                <Button disabled={generatePronounsDetails} onClick={() => handlerPronounDetails("spanish")} variant="contained" color="primary" style={{ background: "#03999e", color: "white" }}> 
                      {generatePronounsDetails ? <Loading white={true} size={18} /> : "Generate Pronouns Details"}
                </Button>
              </span>
            }
          >
            <div className="flex flex-col gap-10px">
              <div className="flex flex-col gap-10px">
                <TextEditor
                  key={questionData?.id}
                  handleChange={(value) => {
                    setNouns((prevNouns) => {
                      const updatedNouns = [...prevNouns];
                      updatedNouns[index] = value;
                      return updatedNouns;
                    });
                  }}
                  value={nouns[index] || ""}
                  autoFocus={false}
                  from={"worksheet"}
                  isOpen={isOpen}
                />
              </div>
            </div>
          </Form.Item>
        </Col>
      </Row>
    </Form>
    </SentryWrap>
  );
};

export default memo(QuestionComponent);

const SaveButton = styled.div``;

const DropdownContainer = styled.div`
  margin-block: 10px;
`;

const HighlightsSection = styled.div`
  margin-bottom: 9px;
  h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
  }
`;

const HighlightsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;
// Updated styled components
const HighlightContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px;
`;

const HighlightItem = styled.div`
  display: flex;
  align-items: center;
  background-color: #e0e0e0;
  border-radius: 20px;
  padding: 8px 12px;
  transition: background-color 0.2s ease;
  gap: 8px;
`;

const HighlightText = styled.span`
  font-size: 14px;
  color: #333;
  margin-right: 4px;
`;

const DeleteButton = styled.button`
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 50%;
  background-color: ${COLORS.red};
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.colors?.redHover || "#ff7875"};
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

const EmptyHighlightItem = styled(HighlightItem)`
  color: black;
  justify-content: center;
`;